import styles from "./SectionSubtitle.module.scss";
import React from "react";

const SectionSubtitle: React.FC<{text: string}> = ({text}) => {
    return (
        <p className={styles.subtitle}>{text}</p>
    )
}

export default SectionSubtitle;